module.exports = __webpack_public_path__ + "img/Laboratorio_de_Lideranca.74698d3b.jpg";